import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import Badge from "@material-ui/core/Badge";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { NavLink } from "react-router-dom";
import avatar from "../static/img_avatar.png";
import NotificationCard from "./Cards/NotificationCard";
import {
  getProfile,
  fetchUserData,
  getUserRoleCount,
} from "../services/userService";
import { useHistory } from "react-router-dom";
import NotificationServices from "../services/notficationService";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import "./Navbar.css";
import "./SideNavBar.css";
import GenericThemeSwitch from "./GenericThemeSwitch";
import isEmptyObject from "../utils/isEmptyObject";
import { connect, useDispatch, useSelector } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";
import TranslateRoundedIcon from "@mui/icons-material/TranslateRounded";
import { getHomeCMS } from "../services/adminServices";
import { withRouter } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Poetlogopen from "../static/POET_Logo_Pen.png";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { matchPath } from "react-router";
import {
  closeLeftNavbar,
  closeRightModalAndOpenLeftNavbar,
  openLeftNavbar,
  openRightModalAndCloseLeftNavbar,
} from "../redux/handleSideNavBarAndModel/handleStatus.action";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  setBlogClick,
  setDocumentClick,
} from "../redux/manageClick/manageClick.action";
import { markAllRead } from "../services/notficationService";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import GavelIcon from "@mui/icons-material/Gavel";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";
import AssessmentIcon from "@mui/icons-material/Assessment";
import FeedIcon from "@mui/icons-material/Feed";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import { Button } from "@material-ui/core";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {
  exitScreen,
  fullscreen,
  fullSizeEditor,
  normalSizeEditor,
} from "../redux/manageFullSizeEditor/fullSizeEditor.action";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import { switchRole } from "../services/userService";
import { Modal } from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import { toast, ToastContainer } from "react-toastify";
import { getFeatures, getRolesForSwitch } from "../services/roleServices";
import { addUserLogs } from "../services/userLogServices";
import { setNavItemForCoauthor } from "../redux/navClickForCoauthor/navclickForCoauthor.action";
import { getUserLogs } from "../services/userLogServices";
import SubscriptionRequired from "./SubscriptionRequired";
import { useCheckSubscriptionPlanAccess } from "./SubscriptionAccess";
import PoetNewlogopen from "../static/loginlogo.png";
import { setUserFeatures } from "../redux/features/features.action";
import { setSubscriptionPlan } from "../redux/subscriptionPlan/subscriptionPlan.action";
import { setRoleFeatures } from "../redux/roleFeatures/roleFeatures.action";
import { fade } from "@material-ui/core/styles/colorManipulator";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const drawerWidth = 250;
const collapsedDrawerWidth = 70;
const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: 10,
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
  },
  grow: {
    flexGrow: 1,
  },
  root: {
    display: "flex",
  },
  appBar: {
    backgroundColor: "#ccced1 !important",
    boxShadow: "none",
    zIndex: theme.zIndex.drawer + 1,
    minHeight: "83px",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    minHeight: "83px",
    marginLeft: drawerWidth,
    width: `calc(99% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  topBar: {
    minHeight: "75px",
    padding: "0 24px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    justifyContent: "space-between",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
  },
  centerSection: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  logoButton: {
    background: "linear-gradient(135deg, #a4bbedff 0%, #83888bff 100%)",
    borderRadius: "12px",
    padding: "8px",
    minWidth: "44px",
    height: "44px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(11, 79, 231, 0.4)",
    },
  },
  brandText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  mainTitle: {
    color: "#0b4fe7",
    fontWeight: 700,
    fontSize: "1.5rem",
    letterSpacing: "-0.5px",
    lineHeight: 1.2,
  },
  subTitle: {
    color: "#4d4f5c",
    fontSize: "0.75rem",
    fontWeight: 400,
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  pageTitle: {
    color: "#0b4fe7",
    fontWeight: 700,
    fontSize: "1.8rem",
    letterSpacing: "-0.5px",
    position: "relative",
  },
  pageSubtitle: {
    color: "#4d4f5c",
    fontSize: "0.875rem",
    fontWeight: 300,
    marginTop: theme.spacing(0.5),
  },
  searchBar: {
    position: "relative",
    width: "400px",
  },
  searchInput: {
    width: "100%",
    padding: "12px 20px 12px 48px",
    background: "rgba(255, 255, 255)",
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    color: "#4d4f5c",
    fontSize: "0.9rem",
    fontWeight: 400,
    transition: "all 0.3s ease",
    "&:focus": {
      outline: "none",
      borderColor: "#0b4fe7",
      boxShadow: "0 0 0 3px rgba(11, 79, 231, 0.1)",
    },
    "&::placeholder": {
      color: "#8d8f9c",
    },
  },
  notificationDot: {
    position: "absolute",
    top: "6px",
    right: "6px",
    width: "8px",
    height: "8px",
    background: "linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)",
    borderRadius: "50%",
    border: "2px solid #ccced1",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  userName: {
    color: "#4d4f5c",
    fontWeight: 600,
    fontSize: "0.9rem",
  },
  userRole: {
    color: "#8d8f9c",
    fontSize: "0.75rem",
    fontWeight: 400,
  },
  // userAvatar: {
  //   width: "40px",
  //   height: "40px",
  //   border: "2px solid #1976d2",
  // },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    position: "relative",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    zIndex: theme.zIndex.drawer,
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      height: "100vh",
      top: 0,
      left: 0,
      zIndex: theme.zIndex.drawer + 2,
      transform: "translateX(-100%)",
      transition: theme.transitions.create("transform", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
  drawerOpen: {
    width: drawerWidth,
    //   [theme.breakpoints.down("sm")]: {
    //     transform: "translateX(0)",
    //   },
    // },
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      transform: "translateX(0)",
    },
  },
  drawerClose: {
    // overflowX: "hidden",
    // width: theme.spacing(7) + 1,
    // [theme.breakpoints.up("sm")]: {
    //   width: theme.spacing(9) + 1,
    // },
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: collapsedDrawerWidth,
    [theme.breakpoints.up("sm")]: {
      width: collapsedDrawerWidth,
    },
  },
  drawerPaper: {
    // background: "linear-gradient(135deg, #000000, #0c7ff3ff)",
    borderRight: "1px solid rgba(255, 255, 255, 0.1)",
    background: "transparent",
    borderBottomRightRadius: "50px",
    overflow: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerContainer: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },

  // content: {
  //   flexGrow: 1,
  //   padding: theme.spacing(3),
  //   backgroundColor: "#f5f5f5",
  //   minHeight: "100vh",
  // },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // marginLeft: collapsedDrawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  toolbar: {
    minHeight: "83px",
  },
  activeNavItem: {
    backgroundColor: "#ffffff !important",
    borderLeft: "3px solid #0c7ff3 !important",
    "& $listItemIcon": {
      color: "#0c7ff3",
    },
    "& $listItemText": {
      color: "#0c7ff3",
      fontWeight: 600,
    },
  },
  navItem: {
    borderRadius: "0 12px 12px 0",
    margin: theme.spacing(0.5, 0),
    padding: theme.spacing(1.3, 2),
    borderLeft: "3px solid transparent",
    width: "100%",
    display: "flex",
    alignItems: "center",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(255, 255, 255, 0.1)",
      borderLeft: "3px solid rgba(12, 127, 243, 0.5)",
    },
  },
  navItemCollapsed: {
    justifyContent: "center",
    padding: theme.spacing(1.3, 0.75),
  },
  listItemIcon: {
    minWidth: 48,
    color: "rgba(255, 255, 255, 0.7)",
  },
  listItemIconCollapsed: {
    minWidth: 0,
    marginRight: 0,
    justifyContent: "center",
  },
  listItemText: {
    color: "rgba(255, 255, 255)",
    fontWeight: 500,
    fontSize: "0.9rem",
    transition: "opacity 0.3s ease",
    opacity: 1,
  },
  listItemTextHidden: {
    opacity: 0,
    width: 0,
    overflow: "hidden",
  },
  sideLogo: {
    // padding: theme.spacing(2, 1.5),
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255)",
    flexShrink: 0,
    maxHeight: "83px",
    transition: "padding 0.3s ease",
  },

  sideLogoCollapsed: {
    padding: theme.spacing(2, 0.5),
    justifyContent: "center",
  },

  sideLogoImage: {
    height: "100%",
    transition: "height 0.3s ease",
  },
  sideLogoImageCollapsed: {
    height: "30px",
  },
  menuListContainer: {
    borderTopLeftRadius: "50px",
    background: "linear-gradient(135deg, #000000, #0c7ff3ff)",
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
  },
  menuItem: {
    padding: theme.spacing(1.5, 2),
    borderRadius: "8px",
    margin: theme.spacing(0.5),
    color: "#4d4f5c",
    "&:hover": {
      background: "rgba(25, 118, 210, 0.1)",
    },
  },
  popoverContent: {
    padding: "8px",
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
  },
  themeSwitch: {
    padding: "4px",
    background: "rgba(25, 118, 210, 0.1)",
    borderRadius: "20px",
  },
  iconButton: {
    "&:hover": {
      backgroundColor: "#B4D9FF",
    },
  },
  notificationBadge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#1976d2",
      color: "#ffffff",
      fontSize: "0.65rem",
      fontWeight: "bold",
      minWidth: 18,
      height: 18,
    },
  },
  dateDisplay: {
    color: "#4d4f5c",
    fontSize: "0.8rem",
    fontWeight: 400,
    letterSpacing: "0.5px",
  },

  actionButton: {
    background: "rgba(25, 118, 210, 0.1)",
    border: "1px solid rgba(25, 118, 210, 0.2)",
    borderRadius: "10px",
    padding: "12px 18px", // Increased from "8px 16px"
    minWidth: "auto",
    color: "#1976d2",
    fontSize: "0.85rem",
    fontWeight: 500,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    height: "50px", // Add fixed height
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      background: "rgba(25, 118, 210, 0.15)",
      transform: "translateY(-2px)",
    },
  },

  notificationButton: {
    position: "relative",
    background: "rgba(25, 118, 210, 0.1)",
    border: "1px solid rgba(25, 118, 210, 0.2)",
    borderRadius: "10px",
    width: "50px", // Increased from "44px"
    height: "50px", // Increased from "44px"
    color: "#1976d2",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(25, 118, 210, 0.15)",
      transform: "translateY(-2px)",
    },
  },

  userMenu: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px", // Increased from "8px 16px"
    background: "rgba(25, 118, 210, 0.1)",
    border: "1px solid rgba(25, 118, 210, 0.2)",
    borderRadius: "12px",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    height: "60px", // Add fixed height
    "&:hover": {
      background: "rgba(25, 118, 210, 0.15)",
      transform: "translateY(-2px)",
    },
  },

  userAvatar: {
    width: "45px", // Increased from "40px"
    height: "45px", // Increased from "40px"
    border: "2px solid #1976d2",
  },

  // appLogoButton: {
  //   marginRight: "38px",
  //   padding: "8px",
  //   background: "linear-gradient(135deg, #a4bbedff 0%, #83888bff 100%)",
  //   borderRadius: "12px",
  //   minWidth: "40px",
  //   height: "60px",
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  //   "&:hover": {
  //     transform: "translateY(-2px)",
  //     boxShadow: "0 8px 25px rgba(11, 79, 231, 0.4)",
  //   },
  //   [theme.breakpoints.down("sm")]: {
  //     marginRight: 0,
  //   },
  // },

  appLogoButton: {
    marginRight: "20px",
    padding: "4px",
    background: "#ffffff", // Changed from gradient to solid white
    borderRadius: "10px",
    minWidth: "50px",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)", // Added subtle shadow for depth
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(0, 0, 0, 0.12)", // Darker shadow on hover since we removed the blue gradient
      backgroundColor: "#f8f9ff", // Slightly off-white on hover for feedback
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },

  hide: {
    display: "none",
  },
}));

function NewHeader(props) {
  const { isFullSize } = useSelector((state) => state.manageFullSizeEditor);
  const classes = useStyles();
  const [AnchorEl, setAnchorEl] = React.useState(false);
  const [profilePic, setProfilePic] = useState("");
  const currentUser = useSelector((state) => state.user.currentUser);
  const isGuest = localStorage.getItem("is_guest") === "true";
  const [username, setusername] = useState(isGuest ? "Guest" : "");
  const [notifications, setnotifications] = useState([]);
  const [alerts, setalerts] = useState([]);
  const theme = useTheme();
  const [open, setOpen] = React.useState();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [cms, setCms] = useState({});
  const [userData, setuserData] = useState({});
  const [bottomText, setBottomText] = useState("");
  const [selectedMenu, setSelectedMenu] = useState("Professional Editing Tool");
  const userRole = sessionStorage.getItem("Role");
  const [orgName, setOrgName] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const { rightModalOpen, leftNavbarOpen } = useSelector(
    (state) => state.handleModelAndSideBavBar,
  );

  const [popoverOpen, setPopoverOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [showSwitchRolePopup, setShowSwitchRolePopup] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [isRoleChanged, setIsRoleChanged] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [userRoles, setUserRoles] = useState([]);
  const [currentUserRole, setCurrentUserRole] = useState("");
  const accessToSwitchRole = useCheckSubscriptionPlanAccess("Switch User");
  const [subReqOpen, setSubReqOpen] = useState(false);

  // Add state for current date
  const [currentDate, setCurrentDate] = useState("");

  // Function to format date as "DD | YYYY"
  // const formatCurrentDate = () => {
  //   const date = new Date();
  //   const day = date.getDate().toString().padStart(2, "0");
  //   const year = date.getFullYear();
  //   return `${day} | ${year}`;
  // };
  const formatCurrentDate = () => {
    const date = new Date();
    const month = date.toLocaleDateString("en-US", { month: "short" });
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day} | ${year}`;
  };

  // Update date function to format as "MMM DD | YYYY" (for the existing formatDate function)
  const formatDate = () => {
    const options = { month: "short", day: "numeric", year: "numeric" };
    const date = new Date();
    const month = date.toLocaleDateString("en-US", { month: "short" });
    const day = date.toLocaleDateString("en-US", { day: "numeric" });
    const year = date.toLocaleDateString("en-US", { year: "numeric" });

    return `${month} ${day} | ${year}`;
  };

  useEffect(() => {
    const isGuest = localStorage.getItem("is_guest") === "true";
    if (isGuest && !currentUser) {
      dispatch(
        setCurrentUser({
          _id: "guest",
          username: "Guest",
          Role: "Guest",
          isGuest: true,
        }),
      );
    }
  }, []);

  // Set current date on component mount
  useEffect(() => {
    setCurrentDate(formatCurrentDate());
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth <= 600) {
        handleDrawerClose();
      }
    };

    window.addEventListener("resize", handleResize);

    // Initialize based on current window width
    if (window.innerWidth <= 600) {
      handleDrawerClose();
    }

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchUserdetails = async () => {
    if (localStorage.getItem("is_guest") === "true") return;
    try {
      const userId = sessionStorage.getItem("userId");
      const data = {
        userId,
      };
      const response = await fetchUserData(data);

      if (response?.user) {
        let subscription = response.user.plan;
        dispatch(setCurrentUser(response.user));
        // setCurrentUser(response?.user);
        setUserDetails(response?.user);
        setUserFeatures(subscription?.features);
        sessionStorage.setItem(
          "subscriptionPlan",
          JSON.stringify(response.user?.plan),
        );

        dispatch(setSubscriptionPlan(subscription));
        const featureResponse = await getFeatures(response?.user?._id);
        if (featureResponse) {
          if (featureResponse?.Features) {
            sessionStorage.setItem(
              "Features",
              JSON.stringify(featureResponse?.Features),
            );
            dispatch(setRoleFeatures(featureResponse?.Features));
          }
        }
      }
    } catch (error) {
      console.log("Error while fetching user data.");
    }
  };

  // useEffect(() => {
  //   fetchUserdetails();
  //   fetchAllRoles();
  // }, []);

  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      if (!isMounted) return;

      await fetchUserdetails();
      await fetchAllRoles();
    };

    init();

    return () => {
      isMounted = false;
    };
  }, []);

  const fetchAllUser = async () => {
    let data = {
      orgId: localStorage.getItem("organizationId"),
      userRole: selectedRole,
    };
    const response = await getUserRoleCount(data);
    let Response2 = await countRegularUser(response.data);
    return Response2;
  };

  const countRegularUser = (data) => {
    let allowedUserRole = sessionStorage.getItem("subscriptionPlan");
    let parsedObject = JSON.parse(allowedUserRole);
    if (currentUserRole === "Power User") {
      if (data >= parsedObject.userCounts.regularUser) {
        return false;
      }
    }
    if (currentUserRole === "Regular User") {
      if (data >= parsedObject.userCounts.powerUser) {
        return false;
      }
    }

    return true;
  };

  useEffect(() => {
    if (isRoleChanged) {
      history.push({
        pathname: `/logout`,
      });
    }
  }, [isRoleChanged]);

  const openSwitchRolePopup = () => {
    if (!accessToSwitchRole) {
      setSubReqOpen(true);
    } else {
      setShowSwitchRolePopup(true);
    }
  };

  const closeSwitchRolePopup = () => {
    setShowSwitchRolePopup(false);
  };

  const rolesForSwitch = userRoles?.filter(
    (role, index) => index !== 0 && role !== currentUserRole,
  );

  const fetchAllRoles = async () => {
    try {
      const repsonse = await getRolesForSwitch();
      if (repsonse?.userRoleList) {
        setUserRoles(repsonse?.userRoleList);
      }
    } catch (error) {
      console.log("Error while fetching all roles.");
    }
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const handleRoleSwitch = async () => {
    try {
      if (!selectedRole) {
        return toast.warn("Role selection is required to proceed.");
      }
      let isSwitchAllowed = await fetchAllUser();
      if (!isSwitchAllowed) {
        return toast.error(`${selectedRole} limit is exceeded`);
      }
      const userId = sessionStorage.getItem("userId");

      const data = {
        userId: userId,
        newRole: selectedRole,
      };
      const response = await switchRole(data);
      if (response.status == 200) {
        toast.success(response.message);
        saveUserLogs();
        setIsRoleChanged(true);
        setShowSwitchRolePopup(false);
      } else {
        toast.error("Error in switching role.");
      }
    } catch (error) {
      toast.error("Internal server error.");
    }
  };

  const saveUserLogs = async () => {
    try {
      const data = {
        userId: userDetails._id,
        organizationId: userDetails.organizationId,
        actionType: "switchRole",
        previousRole: currentUserRole,
        newRole: selectedRole,
      };
      const addLogs = await addUserLogs(data);
      if (addLogs.status !== 200) {
        toast.error(addLogs.message);
      }
    } catch (error) {
      toast.error("Error in saving user logs.");
    }
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mobileView = windowWidth <= 600;

  const togglePopover = () => {
    setPopoverOpen(!popoverOpen);
  };

  useEffect(() => {
    let isMounted = true;
    const fetchProfile = async () => {
      if (!isMounted) return;

      if (isGuest) {
        setusername("Guest");
        setCurrentUserRole("Guest User");
        return;
      }
      try {
        const currentUser = await getProfile();
        if (!isMounted) return;

        setOrgName(currentUser.data.organizationName);
        setCurrentUserRole(currentUser?.data?.userRole);
        setusername(currentUser?.data?.username);
        dispatch(setCurrentUser(currentUser.data));
      } catch (error) {
        console.error("Failed to fetch profile:", error);
      }
    };
    fetchProfile();
    return () => {
      isMounted = false;
    };
  }, [isGuest]);

  useEffect(() => {
    if (mobileView) {
      handleDrawerClose();
    }
  }, []);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const capitalizeFirstLetter = (string) => {
      if (!string) return "";
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    if (currentPath.includes("/viewmydocuments/")) {
      setSelectedMenu("Documents");
      return;
    }

    const capitalizedUsername = capitalizeFirstLetter(username);
    switch (currentPath) {
      case "/paraphrase":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/dashboard":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/texteditor":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/mydocuments":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/myteam":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/docTags":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/citation":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/plagiarism":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/coauthor":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/Summarizer":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/translator":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/reports":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/faq":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/alerts":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/grammarcheck":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/blogpage":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/accountsettings":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/pricing":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/invoices":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/contactUs":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/chat":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/coauthor-newproject":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/mynewdocuments":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      default:
        setSelectedMenu("Professional Editing Tool");
        setBottomText(""); // Clear bottom text for default menu
    }
  }, [username, orgName]);

  useEffect(() => {
    const prevPath = sessionStorage.getItem("previousPath");
    const currPath = location.pathname;

    sessionStorage.setItem(
      "previousPath",
      sessionStorage.getItem("currentPath"),
    );
    sessionStorage.setItem("currentPath", currPath);
  }, [location.pathname]);

  const history = useHistory();

  const markAllNotificationsRead = async () => {
    try {
      if (notifications.notificationsCount < 1) {
        return;
      }

      let details = await markAllRead();
      if (details.status === 200) {
        getNotifications();
      }
    } catch (error) {
      console.error("Error marking all notifications as read:", error.message);
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getCms = async () => {
    const { currentUser, setCurrentUser } = props;
    if (localStorage.getItem("is_guest") === "true") return;
    let cms = await getHomeCMS();
    setCms(cms.data);
  };

  // useEffect(() => {
  //   async function getUser() {
  //     const { currentUser, setCurrentUser } = props;
  //     if (!JSON.stringify(currentUser)) {
  //       let user = (user = await getProfile());
  //       user = { ...user.data };
  //       setuserData(user);
  //       setCurrentUser(user);
  //     }
  //   }
  //   getUser();
  //   getNotifications();
  //   getAlerts();
  //   displyPic();
  //   getCms();
  // }, [rightModalOpen, leftNavbarOpen]);

  // useEffect(() => {
  //   const { currentUser } = props;
  //   setOpen(currentUser.sidenavOption);
  // }, [props]);

  // useEffect(() => {

  //   console.log("👤 getUser useEffect fired", {
  //     isGuest: localStorage.getItem("is_guest"),
  //   });
  //   async function getUser() {
  //     const { currentUser, setCurrentUser } = props;

  //     // ✅ Never call profile API for guest
  //     if (localStorage.getItem("is_guest") === "true") {
  //       return;
  //     }

  //     // ✅ Only fetch if truly empty
  //    if (!currentUser && !isGuest) {
  //       try {
  //         console.log("❗ getUser calling getProfile");
  //         let user = await getProfile();
  //         user = { ...user.data };
  //         setuserData(user);
  //         setCurrentUser(user);
  //       } catch (e) {
  //         console.log("Profile fetch skipped:", e.message);
  //       }
  //     }
  //   }

  //   getUser();
  //   getNotifications();
  //   getAlerts();
  //   displyPic();
  //   getCms();
  // }, [rightModalOpen, leftNavbarOpen]);

  useEffect(() => {
    console.log("👤 getUser useEffect fired", { currentUser, isGuest });
    let isMounted = true;
    if (isGuest) {
      console.log("🟢 Guest detected — skipping profile fetch");
      return;
    }

    const fetchUser = async () => {
      if (!currentUser) {
        try {
          let user = await getProfile();
          if (!isMounted) return;
          dispatch(setCurrentUser(user.data));
        } catch (e) {
          console.log("Profile fetch skipped:", e.message);
        }
      }
    };

    fetchUser();
    return () => {
      isMounted = false;
    };
  }, [currentUser]);

  useEffect(() => {
    const { currentUser } = props;

    if (currentUser?.sidenavOption) {
      setOpen(currentUser.sidenavOption);
    }
  }, [props.currentUser]);

  const notfication_popover = (
    <Popover id="popover-basic" style={{ zIndex: "9999", minWidth: "400px" }}>
      <Popover.Content
        style={{
          overflowY: "auto",
          maxHeight: "40vh",
          position: "relative",
          minWidth: "400px",
        }}
      >
        <div
          className="notification-div"
          style={{
            position: "sticky",
            top: -7,
            zIndex: 1,
            paddingTop: "5px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h6>
              <b>Notification</b>
            </h6>
          </div>
          <div>
            <p
              style={{
                color: "#1976d2",
                fontSize: "10px",
                position: "relative",
                bottom: "-4px",
                cursor: "pointer",
              }}
              onClick={() => {
                markAllNotificationsRead();
                togglePopover();
              }}
            >
              Mark all as read
            </p>
          </div>
        </div>
        <hr />
        <NotificationCard data={notifications} />
      </Popover.Content>
    </Popover>
  );

  const handleDrawerOpen = () => {
    setOpen(true);
    dispatch(closeRightModalAndOpenLeftNavbar());
  };

  const handleDrawerClose = () => {
    setOpen(false);
    dispatch(closeLeftNavbar());
  };

  const menuId = "primary-search-account-menu";
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const getAlerts = async () => {
    if (localStorage.getItem("is_guest") === "true") return;
    let alerts = await NotificationServices.getAlerts();
    setalerts(alerts);
  };

  const getNotifications = async () => {
    if (localStorage.getItem("is_guest") === "true") return;
    let notifications = await NotificationServices.getnotifications();
    setnotifications(notifications);
  };

  const handleBlogClick = () => {
    dispatch(setBlogClick());
    dispatch(setNavItemForCoauthor("blogs"));
  };

  const handleDocumentClick = (navItem) => {
    dispatch(setDocumentClick());
    if (navItem == "mydocuments") {
      dispatch(setNavItemForCoauthor("Documents"));
    }
    if (navItem == "grammarcheck") {
      dispatch(setNavItemForCoauthor("grammerChaeck"));
    }
    if (navItem == "coauthor") {
      dispatch(setNavItemForCoauthor("coAuthor"));
    }
  };

  const handleTagsClick = () => {
    dispatch(setNavItemForCoauthor("Tags"));
  };

  const displyPic = async () => {
    console.log("GUEST CHECK", isGuest);
    console.log("🖼️ displyPic called", {
      isGuest: localStorage.getItem("is_guest"),
    });
    if (localStorage.getItem("is_guest") === "true") {
      setProfilePic("");
      setusername("Guest");
      return;
    }
    let user;
    const { currentUser, setCurrentUser } = props;
    if (currentUser && !isEmptyObject(currentUser)) {
      user = { ...currentUser };
      user["status"] = 200;
    } else {
      console.log("❗ About to call getProfile in displyPic");
      user = user = await getProfile();
      console.log("❗ getProfile result:", user);
      user = user.data;
      setCurrentUser(user);
    }
    if (user.status === 200) {
      const { display_picture, username } = user;
      setProfilePic(display_picture);
      setusername(username);
    }
  };

  const mobileMenuId = "primary-search-account-menu-mobile";

  const dropdown_popover = (
    <Popover id="popover-basic" style={{ zIndex: "9999" }}>
      <Popover.Content>
        <NavLink
          to={{ pathname: "/accountsettings" }}
          style={{ color: "black" }}
        >
          <MenuItem
            onClick={handleMenuClose}
            className={isUrlMatch("/accountsettings") && "background-grey"}
          >
            <Typography>Account Settings</Typography>
          </MenuItem>
        </NavLink>
        {props.currentUser &&
          ((props.currentUser.Role === "Organization" &&
            props.currentUser.isAdmin === true) ||
            props.currentUser.Role === "Individual") && (
            <NavLink
              to={{ pathname: "/pricing" }}
              style={{ color: "black", paddingTop: "2px" }}
            >
              <MenuItem
                onClick={handleMenuClose}
                className={isUrlMatch("/pricing") && "background-grey"}
              >
                Subscriptions
              </MenuItem>
            </NavLink>
          )}

        {props.currentUser && props.currentUser.accountType === "Personal" && (
          <NavLink to={{ pathname: "/invoices" }} style={{ color: "black" }}>
            <MenuItem
              onClick={handleMenuClose}
              className={isUrlMatch("/invoices") && "background-grey"}
            >
              Invoices
            </MenuItem>
          </NavLink>
        )}

        <NavLink to={{ pathname: "/contactUs" }} style={{ color: "black" }}>
          <MenuItem onClick={handleMenuClose}>Support</MenuItem>
        </NavLink>
        <NavLink to={{ pathname: "/logout" }} style={{ color: "black" }}>
          <MenuItem onClick={handleMenuClose}>Log Out</MenuItem>
        </NavLink>
      </Popover.Content>
    </Popover>
  );

  function isUrlMatch(path) {
    return matchPath(location.pathname, {
      path,
      exact: true,
      strict: false,
    });
  }

  const getThemeSwitch = () => {
    return (
      <div className={classes.themeSwitch}>
        <GenericThemeSwitch />
      </div>
    );
  };

  const handleMenuSelection = (menuName) => {
    setSelectedMenu(menuName);
  };

  useEffect(() => {
    handleMenuSelection(selectedMenu);
    const container = document.querySelector(".MuiDrawer-paper");
    if (container) {
      if (
        selectedMenu == "Summarizer" ||
        selectedMenu == "Translator" ||
        selectedMenu == "Reports" ||
        selectedMenu == "Tags" ||
        selectedMenu == "Blogs" ||
        selectedMenu == "FAQ"
      ) {
        container.scrollTop = 320;
      } else {
        container.scrollTop = 0;
      }
    }
  }, [selectedMenu]);

  const [isFullscreen, setIsFullscreen] = useState(false);

  const enterFullscreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
    setIsFullscreen(true);
    dispatch(fullscreen());
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullscreen(false);
    dispatch(exitScreen());
  };

  // const toggleFullscreen = () => {
  //   if (!isFullscreen) {
  //     enterFullscreen();
  //   } else {
  //     exitFullscreen();
  //   }
  // };
  const toggleFullscreen = async () => {
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
        setIsFullscreen(true);
        dispatch(fullscreen());
      } else {
        await document.exitFullscreen();
        setIsFullscreen(false);
        dispatch(exitScreen());
      }
    } catch (error) {
      console.error("Fullscreen error:", error);
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setIsFullscreen(false);
      } else {
        setIsFullscreen(true);
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: leftNavbarOpen,
        })}
      >
        <Toolbar
          className={classes.toolbar}
          style={{
            padding: 0,
            paddingRight: "20px",
            minHeight: "83px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Logo Button in AppBar - Click to open sidebar */}
          <LightTooltip title="Click to Expand">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.appLogoButton, {
                [classes.hide]: leftNavbarOpen,
              })}
              style={{
                height: "60px",
                width: "65px",
                marginLeft: !leftNavbarOpen ? "5px" : "0",
                position: "relative",
                zIndex: 1000,
                padding: "4px",
              }}
            >
              <img
                alt="logo"
                className="img-fluid lcss"
                src={Poetlogopen}
                style={{
                  height: "60px",
                  width: "65px",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </IconButton>
          </LightTooltip>

          {/* Username and Date Section - Left side after logo */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "24px",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <Typography
                style={{
                  fontSize: "1.6rem",
                  fontWeight: 800,
                  background:
                    "linear-gradient(135deg, #1b2ad7ff 0%, #1b2ad7ff 0%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  color: "transparent",
                  lineHeight: 1.2,
                  letterSpacing: "-0.5px",
                  fontFamily: "'Poppins', 'Segoe UI', sans-serif",
                }}
              >
                Welcome
              </Typography>
              <Typography
                style={{
                  fontSize: "1.6rem",
                  fontWeight: 800,
                  background:
                    "linear-gradient(135deg,  #1b2ad7ff 0%, #1b2ad7ff 0%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  color: "transparent",
                  lineHeight: 1.2,
                  letterSpacing: "-0.5px",
                  fontFamily: "'Poppins', 'Segoe UI', sans-serif",
                }}
              >
                {isGuest ? "Guest" : username}
              </Typography>
            </div>

            <Typography
              style={{
                fontSize: "1.25rem",
                color: "#5c6bc0",
                fontWeight: 500,
                letterSpacing: "0.5px",
                marginTop: "6px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontFamily: "'Inter', 'Roboto', sans-serif",
              }}
            >
              {/* <span style={{ fontSize: "1rem" }}>📅</span> */}
              {currentDate}
            </Typography>
          </div>

          {/* Spacer to push everything else to the right */}
          <div className={classes.grow} style={{ height: "100%" }} />

          {/* Right side actions */}
          <div
            className={classes.rightSection}
            style={{ height: "100%", alignItems: "center" }}
          >
            {/* Fullscreen Toggle */}
            <LightTooltip
              title={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              <IconButton
                className={classes.actionButton}
                onClick={toggleFullscreen}
                style={{ height: "50px" }}
              >
                {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </LightTooltip>

            {/* Switch Role */}
            {userDetails?.originalRole?.userRole == userRoles[1] && (
              <LightTooltip title={"Switch Role"}>
                <IconButton
                  className={classes.actionButton}
                  onClick={openSwitchRolePopup}
                  style={{ height: "50px" }}
                >
                  <SwitchAccountIcon />
                </IconButton>
              </LightTooltip>
            )}

            <SubscriptionRequired open={subReqOpen} setOpen={setSubReqOpen} />

            {/* Theme Switch */}
            {/* <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
        {getThemeSwitch()}
      </div> */}

            {/* Notifications */}
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={notfication_popover}
              rootClose={true}
              show={popoverOpen}
            >
              <LightTooltip title="Notifications">
                <IconButton
                  className={classes.notificationButton}
                  onClick={togglePopover}
                  disabled={notifications.notificationsCount < 1}
                  style={{ height: "50px", width: "50px" }}
                >
                  <Badge
                    badgeContent={
                      notifications.notificationsCount > 0
                        ? notifications.notificationsCount
                        : null
                    }
                    color="secondary"
                    className={classes.notificationBadge}
                  >
                    <NotificationsIcon />
                  </Badge>
                  {notifications.notificationsCount > 0 && (
                    <div className={classes.notificationDot} />
                  )}
                </IconButton>
              </LightTooltip>
            </OverlayTrigger>

            {/* User Menu */}
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={dropdown_popover}
              rootClose={true}
            >
              <div
                className={classes.userMenu}
                style={{ height: "60px", alignItems: "center" }}
              >
                <Avatar
                  src={profilePic || avatar}
                  alt={username}
                  className={classes.userAvatar}
                  style={{ width: "45px", height: "45px" }}
                />
                <div className={classes.userInfo}>
                  <Typography className={classes.userName}>
                    {isGuest ? "Guest" : username}
                  </Typography>
                  <Typography className={classes.userRole}>
                    {isGuest ? "Guest User" : currentUserRole}
                  </Typography>
                </div>
              </div>
            </OverlayTrigger>
          </div>
        </Toolbar>
      </AppBar>

      {/* Switch Role Modal */}
      <Modal
        isOpen={showSwitchRolePopup}
        toggle={() => setShowSwitchRolePopup(!showSwitchRolePopup)}
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "50%",
        }}
      >
        <div style={{ padding: "25px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 style={{ color: "#1976D2", marginBottom: "0px" }}>
              Switch Role
            </h3>
            <CloseIcon
              style={{ color: "red" }}
              onClick={closeSwitchRolePopup}
            />
          </div>

          <div style={{ width: "85%", margin: " 22px auto" }}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="userRole"
                name="userRole"
                value={selectedRole}
                onChange={handleRoleChange}
              >
                {rolesForSwitch.map((role, index) => (
                  <FormControlLabel
                    key={index}
                    value={role}
                    control={<Radio />}
                    label={role}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={handleRoleSwitch}
              style={{ color: "white", backgroundColor: "#1976d2" }}
            >
              Switch
            </Button>
          </div>
        </div>
      </Modal>

      {/* Sidebar Drawer */}
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: leftNavbarOpen,
          [classes.drawerClose]: !leftNavbarOpen,
        })}
        classes={{
          paper: clsx(classes.drawerPaper, {
            [classes.drawerOpen]: leftNavbarOpen,
            [classes.drawerClose]: !leftNavbarOpen,
          }),
        }}
        open={mobileOpen}
        onClose={handleDrawerToggle}
        id="normalsidenav"
      >
        {/* Container for fixed layout */}
        {/* <div className={classes.drawerContainer}> */}
        {/* Logo Section - Fixed at top */}
        {/* <div className={classes.sideLogo}>
            <IconButton
              onClick={handleDrawerClose}
              size="small"
              style={{
                position: "absolute",
                right: 8,
                backgroundColor: fade("#667eea", 0.1),
                color: "#667eea",
              }}
            >
              <ChevronLeftIcon />
            </IconButton> */}
        {/* <img
              alt="logo"
              src={PoetNewlogopen}
              // src={Poetlogopen}
              className={classes.sideLogoImage}
              style={{
                height: "100%",
                marginRight: "50px",
              }}
            /> */}
        {/* </div> */}
        {/* Logo Section - Fixed at top */}
        <div className={classes.drawerContainer}>
          <div className={classes.sideLogo}>
            <IconButton
              onClick={handleDrawerClose}
              size="small"
              style={{
                position: "absolute",
                right: 8,
                backgroundColor: fade("#667eea", 0.1),
                color: "#667eea",
              }}
            >
              <ChevronLeftIcon />
            </IconButton>

            {/* Left side: Logo */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                gap: "5px",
              }}
            >
              <img
                alt="logo"
                src={Poetlogopen}
                className={classes.sideLogoImage}
                style={{
                  height: "100px",
                  width: "auto",
                  objectFit: "contain",
                }}
              />

              {/* Right side: Text - only visible when sidebar is open */}
              {leftNavbarOpen && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    overflow: "hidden",
                  }}
                >
                  <Typography
                    style={{
                      color: "#0b4fe7",
                      fontWeight: 700,
                      fontSize: "1.4rem",
                      lineHeight: 1.3,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Synthium
                  </Typography>
                  <Typography
                    style={{
                      color: "#4d4f5c",
                      fontSize: "0.95rem",
                      fontWeight: 500,
                      lineHeight: 1.3,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Creative Suite
                  </Typography>
                </div>
              )}
            </div>
          </div>

          {/* Scrollable Menu List */}
          <div className={classes.menuListContainer}>
            <List
              className="drawerMenu pointer"
              id="menuList"
              style={{
                borderTopRightRadius: "50px",
                // padding: "0",
              }}
            >
              <ListItem
                button
                onClick={() => {
                  window.location.href = "/dashboard";
                }}
                // to="/dashboard"
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]: isUrlMatch("/dashboard"),
                    [classes.navItemCollapsed]: !leftNavbarOpen,
                  })}
                >
                  <ListItemIcon
                    className={clsx(classes.listItemIcon, {
                      [classes.listItemIconCollapsed]: !leftNavbarOpen,
                    })}
                  >
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "Dashboard"}
                      placement="right"
                    >
                      <DashboardOutlinedIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      Dashboard
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                // to="/mydocuments"
                style={{ textDecoration: "none" }}
                onClick={() => {
                  handleDocumentClick("mydocuments");
                  window.location.href = "/mydocuments";
                }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]:
                      isUrlMatch("/mydocuments") ||
                      isUrlMatch("/documentpreview/:id") ||
                      isUrlMatch("/viewmydocuments/:id"),
                    [classes.navItemCollapsed]: !leftNavbarOpen,
                  })}
                >
                  <ListItemIcon
                    className={clsx(classes.listItemIcon, {
                      [classes.listItemIconCollapsed]: !leftNavbarOpen,
                    })}
                  >
                    <LightTooltip
                      title={leftNavbarOpen ? "" : " SmartDoc Library"}
                      placement="right"
                    >
                      <DescriptionOutlinedIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      SmartDoc Library
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                // to="/grammarcheck"
                style={{ textDecoration: "none" }}
                // onClick={() => handleDocumentClick("grammarcheck")}
                onClick={() => {
                  handleDocumentClick("grammarcheck");
                  window.location.href = "/grammarcheck";
                }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]: isUrlMatch("/grammarcheck"),
                    [classes.navItemCollapsed]: !leftNavbarOpen,
                  })}
                >
                  <ListItemIcon
                    className={clsx(classes.listItemIcon, {
                      [classes.listItemIconCollapsed]: !leftNavbarOpen,
                    })}
                  >
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "Grammar Check"}
                      placement="right"
                    >
                      <SpellcheckIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      Grammar Check
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  window.location.href = "/myteam";
                }}
                // to="/myteam"
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]: isUrlMatch("/myteam"),
                    [classes.navItemCollapsed]: !leftNavbarOpen,
                  })}
                >
                  <ListItemIcon
                    className={clsx(classes.listItemIcon, {
                      [classes.listItemIconCollapsed]: !leftNavbarOpen,
                    })}
                  >
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "Team Hub"}
                      placement="right"
                    >
                      <GroupOutlinedIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      Team Hub
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                // to="/coauthor"
                style={{ textDecoration: "none" }}
                // onClick={() => handleDocumentClick("coauthor")}
                onClick={() => {
                  handleDocumentClick("coauthor");
                  window.location.href = "/coauthor";
                }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]:
                      isUrlMatch("/coauthor") ||
                      isUrlMatch("/coauthor-newproject"),
                    [classes.navItemCollapsed]: !leftNavbarOpen,
                  })}
                >
                  <ListItemIcon
                    className={clsx(classes.listItemIcon, {
                      [classes.listItemIconCollapsed]: !leftNavbarOpen,
                    })}
                  >
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "Synthium Studio"}
                      placement="right"
                    >
                      <EditNoteIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      Synthium Studio
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  window.location.href = "/reports";
                }}
                // to="/reports"
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]: isUrlMatch("/reports"),
                    [classes.navItemCollapsed]: !leftNavbarOpen,
                  })}
                >
                  <ListItemIcon
                    className={clsx(classes.listItemIcon, {
                      [classes.listItemIconCollapsed]: !leftNavbarOpen,
                    })}
                  >
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "AI Intelligence"}
                      placement="right"
                    >
                      <AssessmentIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      AI Intelligence
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                // to="/docTags"
                style={{ textDecoration: "none" }}
                onClick={() => {
                  handleTagsClick(); // keep your redux logic
                  window.location.href = "/docTags"; // force full reload
                }}
                // onClick={() => handleTagsClick()}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]:
                      isUrlMatch("/docTags") ||
                      isUrlMatch("/Summarizer") ||
                      isUrlMatch("/paraphrase") ||
                      isUrlMatch("/translator") ||
                      isUrlMatch("/plagiarism") ||
                      isUrlMatch("/citation"),
                    [classes.navItemCollapsed]: !leftNavbarOpen,
                  })}
                >
                  <ListItemIcon
                    className={clsx(classes.listItemIcon, {
                      [classes.listItemIconCollapsed]: !leftNavbarOpen,
                    })}
                  >
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "MultiTool AI"}
                      placement="right"
                    >
                      <LocalOfferIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      MultiTool AI
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                // to="/blogpage"
                style={{ textDecoration: "none" }}
                // onClick={handleBlogClick}
                onClick={() => {
                  handleBlogClick();
                  window.location.href = "/blogpage";
                }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]:
                      isUrlMatch("/blogpage") || isUrlMatch("/blogpreview/:id"),
                    [classes.navItemCollapsed]: !leftNavbarOpen,
                  })}
                >
                  <ListItemIcon
                    className={clsx(classes.listItemIcon, {
                      [classes.listItemIconCollapsed]: !leftNavbarOpen,
                    })}
                  >
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "Blogs"}
                      placement="right"
                    >
                      <FeedIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      Blogs
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                // to="/faq"
                onClick={() => {
                  window.location.href = "/faq";
                }}
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]: isUrlMatch("/faq"),
                    [classes.navItemCollapsed]: !leftNavbarOpen,
                  })}
                >
                  <ListItemIcon
                    className={clsx(classes.listItemIcon, {
                      [classes.listItemIconCollapsed]: !leftNavbarOpen,
                    })}
                  >
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "FAQ"}
                      placement="right"
                    >
                      <HelpOutlineIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      FAQ
                    </Typography>
                  )}
                </ListItem>
              </ListItem>
            </List>
          </div>
        </div>
      </Drawer>

      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  isAuth: state.user.isAuth,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
  setUserFeatures: (features) => dispatch(setUserFeatures(features)),
  setRoleFeatures: (roleFeatures) => dispatch(setRoleFeatures(roleFeatures)),
  setSubscriptionPlan: (plan) => dispatch(setSubscriptionPlan(plan)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(NewHeader));




// import React, { useEffect, useState } from "react";
// import clsx from "clsx";
// import { Popover, OverlayTrigger } from "react-bootstrap";
// import { makeStyles, withStyles } from "@material-ui/core/styles";
// import Drawer from "@material-ui/core/Drawer";
// import AppBar from "@material-ui/core/AppBar";
// import Toolbar from "@material-ui/core/Toolbar";
// import List from "@material-ui/core/List";
// import CssBaseline from "@material-ui/core/CssBaseline";
// import Typography from "@material-ui/core/Typography";
// import IconButton from "@material-ui/core/IconButton";
// import MenuItem from "@material-ui/core/MenuItem";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import Avatar from "@material-ui/core/Avatar";
// import Badge from "@material-ui/core/Badge";
// import NotificationsIcon from "@material-ui/icons/Notifications";
// import { NavLink } from "react-router-dom";
// import avatar from "../static/img_avatar.png";
// import NotificationCard from "./Cards/NotificationCard";
// import {
//   getProfile,
//   fetchUserData,
//   getUserRoleCount,
// } from "../services/userService";
// import { useHistory } from "react-router-dom";
// import NotificationServices from "../services/notficationService";
// import LocalOfferIcon from "@material-ui/icons/LocalOffer";
// import "./Navbar.css";
// import "./SideNavBar.css";
// import isEmptyObject from "../utils/isEmptyObject";
// import { connect, useDispatch, useSelector } from "react-redux";
// import { setCurrentUser } from "../redux/user/user.actions";
// import { withRouter } from "react-router-dom";
// import Tooltip from "@material-ui/core/Tooltip";
// import Poetlogopen from "../static/POET_Logo_Pen.png";
// import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
// import { matchPath } from "react-router";
// import {
//   closeLeftNavbar,
//   closeRightModalAndOpenLeftNavbar,
// } from "../redux/handleSideNavBarAndModel/handleStatus.action";
// import {
//   setBlogClick,
//   setDocumentClick,
// } from "../redux/manageClick/manageClick.action";
// import { markAllRead } from "../services/notficationService";
// import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import SpellcheckIcon from "@mui/icons-material/Spellcheck";
// import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
// import EditNoteIcon from "@mui/icons-material/EditNote";
// import AssessmentIcon from "@mui/icons-material/Assessment";
// import FeedIcon from "@mui/icons-material/Feed";
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
// import {
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   FormControl,
// } from "@mui/material";
// import { Button } from "@material-ui/core";
// import FullscreenIcon from "@mui/icons-material/Fullscreen";
// import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
// import {
//   exitScreen,
//   fullscreen,
// } from "../redux/manageFullSizeEditor/fullSizeEditor.action";
// import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
// import { switchRole } from "../services/userService";
// import { Modal } from "reactstrap";
// import CloseIcon from "@material-ui/icons/Close";
// import { toast } from "react-toastify";
// import { getFeatures, getRolesForSwitch } from "../services/roleServices";
// import { addUserLogs } from "../services/userLogServices";
// import { setNavItemForCoauthor } from "../redux/navClickForCoauthor/navclickForCoauthor.action";
// import SubscriptionRequired from "./SubscriptionRequired";
// import { useCheckSubscriptionPlanAccess } from "./SubscriptionAccess";
// import { setUserFeatures } from "../redux/features/features.action";
// import { setSubscriptionPlan } from "../redux/subscriptionPlan/subscriptionPlan.action";
// import { setRoleFeatures } from "../redux/roleFeatures/roleFeatures.action";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import { GlobalStyles } from "@mui/material";

// const GALAXY_BACKGROUND = `
//  linear-gradient(135deg,
//   #f200ff 0%,
//   #000000 20%,
//   #e4dcff 40%,
//   #dcd2ff 60%,
//   #3200f8 80%,
//   #e71a1a 100%
// )
//   // linear-gradient(165deg,
//   //   rgb(3, 0, 79) 0%,
//   //   #0e0157 10%,
//   //   #0b0141 20%,
//   //   #0d014e 30%,
//   //   #0b1f75 40%,
//   //   #2e32b2 48%,
//   //   #5be298 56%,
//   //   #36fff8 64%,
//   //   #1efe00 73%,
//   //   #ff9b05 82%,
//   //   #1100ff 90%,
//   //   #000b83 100%
//   // )
// `;
// const STARS = Array.from({ length: 90 }, (_, i) => {
//   const px = ((i * 2539 + 419) % 10000) / 100;
//   const py = ((i * 1733 + 137) % 10000) / 100;
//   const sz = i % 11 === 0 ? 3.4 : i % 5 === 0 ? 2.2 : i % 3 === 0 ? 1.6 : 1.0;
//   const dl = ((i * 0.31) % 5.5).toFixed(2);
//   const dr = (1.6 + (i % 8) * 0.45).toFixed(1);
//   const bright = i % 6 === 0;
//   return { px, py, sz, dl, dr, bright };
// });

// const STAR_CSS = STARS.map(
//   (s, i) => `
//   .gxs${i} {
//     position: fixed;
//     left: ${s.px}%;
//     top: ${s.py}%;
//     width: ${s.sz}px;
//     height: ${s.sz}px;
//     border-radius: 50%;
//     background: #ffffff;
//     box-shadow:
//       0 0 ${(s.sz * 3).toFixed(1)}px rgba(255,255,255,0.95),
//       0 0 ${(s.sz * 1.5).toFixed(1)}px rgba(255,255,255,0.80)
//       ${s.bright ? `, 0 0 ${(s.sz * 7).toFixed(1)}px rgba(255,255,255,0.50)` : ""};
//     animation: gxTwinkle ${s.dr}s ease-in-out ${s.dl}s infinite;
//     pointer-events: none;
//     z-index: 0;
//   }
// `,
// ).join("");

// const drawerWidth = 250;
// const collapsedWidth = 70;
// const NavTooltip = withStyles(() => ({
//   tooltip: {
//     background: "rgba(50, 18, 115, 0.94)",
//     color: "#f0e8ff",
//     backdropFilter: "blur(14px)",
//     WebkitBackdropFilter: "blur(14px)",
//     border: "1px solid rgba(210,175,255,0.28)",
//     boxShadow: "0 4px 22px rgba(0,0,0,0.28)",
//     fontSize: 11,
//     borderRadius: 8,
//     padding: "5px 12px",
//   },
// }))(Tooltip);

// // Add this component — uses position:absolute, more stars, stronger glow
// const SideNavStars = () => {
//   const sideStars = Array.from({ length: 60 }, (_, i) => {
//     const px = ((i * 3127 + 811) % 10000) / 100;
//     const py = ((i * 2341 + 503) % 10000) / 100;
//     const sz = i % 9 === 0 ? 4.0 : i % 5 === 0 ? 2.8 : i % 3 === 0 ? 1.8 : 1.1;
//     const dl = ((i * 0.27) % 4.8).toFixed(2);
//     const dr = (1.4 + (i % 7) * 0.5).toFixed(1);
//     return { px, py, sz, dl, dr };
//   });

//   return (
//     <div
//       style={{
//         position: "absolute",
//         inset: 0,
//         pointerEvents: "none",
//         zIndex: 0,
//         overflow: "hidden",
//       }}
//     >
//       {sideStars.map((s, i) => (
//         <div
//           key={i}
//           style={{
//             position: "absolute",
//             left: `${s.px}%`,
//             top: `${s.py}%`,
//             width: `${s.sz}px`,
//             height: `${s.sz}px`,
//             borderRadius: "50%",
//             background: "#ffffff",
//             boxShadow: `
//               0 0 ${(s.sz * 4).toFixed(1)}px rgba(255,255,255,1),
//               0 0 ${(s.sz * 8).toFixed(1)}px rgba(220,190,255,0.9),
//               0 0 ${(s.sz * 14).toFixed(1)}px rgba(190,150,255,0.6),
//               0 0 ${(s.sz * 22).toFixed(1)}px rgba(160,120,255,0.3)
//             `,
//             animation: `gxTwinkle ${s.dr}s ease-in-out ${s.dl}s infinite`,
//           }}
//         />
//       ))}
//     </div>
//   );
// };


// const useStyles = makeStyles((theme) => ({
//   root: { display: "flex" },
//   appBar: {
//     background: "rgb(109, 55, 195) !important",
//     backdropFilter: "blur(36px) saturate(185%) !important",
//     WebkitBackdropFilter: "blur(36px) saturate(185%) !important",
//     borderBottom: "1px solid rgba(255,255,255,0.30) !important",
//     boxShadow:
//       "0 2px 28px rgba(80,30,155,0.18), inset 0 1px 0 rgba(255,255,255,0.28) !important",
//     zIndex: theme.zIndex.drawer + 1,
//     minHeight: "83px",
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//   },
//   appBarShift: {
//     minHeight: "83px",
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   toolbar: {
//     minHeight: "83px",
//     padding: "0 20px 0 14px",
//     display: "flex",
//     alignItems: "center",
//   },
//   toolbar2: { minHeight: "83px" },
//   grow: { flexGrow: 1 },

//   logoBtn: {
//     marginRight: "14px",
//     padding: "6px",
//     background: "rgb(255, 255, 255)",
//     backdropFilter: "blur(14px)",
//     borderRadius: "13px",
//     border: "1px solid rgba(255,255,255,0.38)",
//     minWidth: "50px",
//     width: "50px",
//     height: "50px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     transition: "all 0.3s ease",
//     "&:hover": {
//       background: "rgba(255,255,255,0.36)",
//       transform: "translateY(-2px)",
//       boxShadow: "0 6px 20px rgba(80,30,155,0.22)",
//     },
//   },

//   welcomeBox: {
//     display: "flex",
//     flexDirection: "column",
//     marginLeft: "14px",
//     justifyContent: "center",
//   },
//   welcomeName: {
//     fontSize: "1.52rem",
//     fontWeight: 800,
//     color: "rgb(55, 45, 246)",
//     lineHeight: 1.2,
//     letterSpacing: "-0.3px",
//     fontFamily: "'Outfit','Segoe UI',sans-serif",

//   },
//   welcomeDate: {
//     fontSize: "0.93rem",
//     color: "rgb(13, 0, 255)",
//     fontWeight: 400,
//     letterSpacing: "0.4px",
//     marginTop: "2px",
//     fontFamily: "'Outfit',sans-serif",
//   },

//   rightRow: {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//     [theme.breakpoints.down("sm")]: { gap: "6px" },
//   },
//   iconBtn: {
//     background: "rgba(255,255,255,0.22) !important",
//     border: "1px solid rgba(145, 84, 252, 0.36) !important",
//     borderRadius: "10px !important",
//     width: "46px !important",
//     height: "46px !important",
//     color: "rgba(67, 43, 244, 0.96) !important",
//     backdropFilter: "blur(14px) !important",
//     transition: "all 0.28s ease !important",
//     "&:hover": {
//       background: "rgba(255,255,255,0.38) !important",
//       transform: "translateY(-2px) !important",
//       boxShadow: "0 6px 18px rgba(80,30,155,0.20) !important",
//     },
//   },
//   notifBtn: {
//     position: "relative",
//     background: "rgba(255,255,255,0.22) !important",
//     border: "1px solid rgba(145, 84, 252, 0.36) !important",
//     borderRadius: "10px !important",
//     width: "46px !important",
//     height: "46px !important",
//     color: "rgba(94, 72, 255, 0.96) !important",
//     backdropFilter: "blur(14px) !important",
//     transition: "all 0.28s ease !important",
//     "&:hover": {
//       background: "rgba(255,255,255,0.38) !important",
//       transform: "translateY(-2px) !important",
//     },
//   },
//   badge: {
//     "& .MuiBadge-badge": {
//       background: "linear-gradient(135deg,#d040c8,#8030b8)",
//       color: "#fff",
//       fontSize: "0.60rem",
//       fontWeight: "bold",
//       minWidth: 16,
//       height: 16,
//     },
//   },
//   notifDot: {
//     position: "absolute",
//     top: "8px",
//     right: "8px",
//     width: "6px",
//     height: "6px",
//     background: "#ff4466",
//     borderRadius: "50%",
//     border: "2px solid rgba(108,55,195,0.55)",
//   },

//   userPill: {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//     padding: "7px 14px",
//     background: "rgb(255, 255, 255)",
//     border: "1px solid rgba(145, 84, 252, 0.36)",
//     borderRadius: "12px",
//     cursor: "pointer",
//     backdropFilter: "blur(14px)",
//     height: "52px",
//     transition: "all 0.28s ease",
//     "&:hover": {
//       background: "rgba(255,255,255,0.32)",
//       transform: "translateY(-2px)",
//       boxShadow: "0 8px 22px rgba(80,30,155,0.18)",
//     },
//   },
//   userAvatar: {
//     width: "36px !important",
//     height: "36px !important",
//     border: "2px solid rgba(225,195,255,0.75) !important",
//     boxShadow: "0 0 10px rgba(185,145,255,0.35) !important",
//   },
//   userTextBox: {
//     display: "flex",
//     flexDirection: "column",
//     [theme.breakpoints.down("sm")]: { display: "none" },
//   },
//   userName: {
//     color: "#3300ff",
//     fontWeight: 600,
//     fontSize: "0.86rem",
//     fontFamily: "'Outfit',sans-serif",
//     lineHeight: 1.2,
//   },
//   userRole: {
//     color: "rgba(11, 31, 248, 0.72)",
//     fontSize: "0.70rem",
//     fontWeight: 400,
//   },

//   drawer: {
//     width: drawerWidth,
//     flexShrink: 0,
//     whiteSpace: "nowrap",
//     position: "relative",
//     zIndex: theme.zIndex.drawer,
//     [theme.breakpoints.down("sm")]: {
//       position: "fixed",
//       height: "100vh",
//       top: 0,
//       left: 0,
//       zIndex: theme.zIndex.drawer + 2,
//       transform: "translateX(-100%)",
//     },
//   },
//   drawerOpen: {
//     width: drawerWidth,
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//     [theme.breakpoints.down("sm")]: { transform: "translateX(0)" },
//   },
//   drawerClose: {
//     overflowX: "hidden",
//     width: collapsedWidth,
//     [theme.breakpoints.up("sm")]: { width: collapsedWidth },
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//   },
//   drawerPaper: {
//     background: "transparent !important",
//     border: "none !important",
//     overflow: "hidden",
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//   },

//   sidePanel: {
//     height: "100vh",
//     display: "flex",
//     flexDirection: "column",
//     background:
//       "linear-gradient(180deg, #0e0157 0%, rgba(162, 146, 248, 0.95) 100%)",
//     backdropFilter: "blur(36px) saturate(175%)",
//     WebkitBackdropFilter: "blur(36px) saturate(175%)",
//     borderRight: "1px solid rgba(255,255,255,0.25)",
//     boxShadow:
//       "4px 0 38px rgba(105, 48, 205, 0.18), inset -1px 0 0 rgba(255,255,255,0.12)",
//     overflow: "hidden",
//     borderBottomRightRadius: "50px",
//   },

//   sideLogoRow: {
//     borderBottom: "1px solid rgba(255,255,255,0.15)",
//     display: "flex",
//     alignItems: "center",
//     background: "rgb(255, 255, 255)",
//     flexShrink: 0,
//     minHeight: "83px",
//     maxHeight: "83px",
//     padding: "0 12px",
//     position: "relative",
//   },
//   sideLogoImg: {
//     height: "54px",
//     width: "auto",
//     objectFit: "contain",
//     filter: "drop-shadow(0 0 9px rgba(205,170,255,0.60))",
//   },

//   navWrapper: {
//     flex: 1,
//     overflow: "hidden",
//     marginTop: "5px",
//     paddingTop: "7px",
//     borderTopLeftRadius: "50px",
//     borderBottomRightRadius: "50px",
//     position: "relative",
//   },

//   navScroll: {
//     height: "100%",
//     flex: 1,
//     overflowY: "auto",
//     overflowX: "hidden",
//     padding: "10px 0",
//     "&::-webkit-scrollbar": { width: "3px" },
//     "&::-webkit-scrollbar-track": { background: "transparent" },
//     "&::-webkit-scrollbar-thumb": {
//       background: "rgba(210,175,255,0.32)",
//       borderRadius: "2px",
//     },
//   },

//   navRow: {
//     borderRadius: "0 14px 14px 0",
//     margin: "1px 8px 1px 0",
//     padding: "15px 14px",
//     borderLeft: "3px solid transparent",
//     transition: "all 0.22s ease",
//     cursor: "pointer",
//     "&:hover": {
//       background: "rgba(255,255,255,0.15)",
//       borderLeft: "3px solid rgba(225,195,255,0.65)",
//     },
//   },
//   navRowActive: {
//     background: "rgba(255,255,255,0.22) !important",
//     borderLeft: "3px solid #ddc8ff !important",
//     boxShadow: "inset 0 0 20px rgba(210,175,255,0.10)",
//   },
//   navIcon: { minWidth: 42, color: "rgb(253, 251, 255)" },
//   navText: {
//     color: "rgb(255, 252, 255)",
//     fontWeight: 500,
//     fontSize: "0.87rem",
//     fontFamily: "'Outfit',sans-serif",
//   },

//   content: {
//     flexGrow: 1,
//     minHeight: "100vh",
//     position: "relative",
//     overflow: "hidden",
//     background: GALAXY_BACKGROUND,
//     transition: theme.transitions.create("margin", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//   },
//   contentShift: {
//     transition: theme.transitions.create("margin", {
//       easing: theme.transitions.easing.easeOut,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   hide: { display: "none" },
// }));

// const GalaxyCSS = () => (
//   <GlobalStyles
//     styles={`
//       @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');

//       /* Star twinkle */
//       @keyframes gxTwinkle {
//         0%, 100% { opacity: 0.12; transform: scale(0.55); }
//         50%       { opacity: 1.00; transform: scale(1.55); }
//       }

//       /* Upper galaxy arm: luminous white sweep bottom-left → top-right */
//       @keyframes gxArm1 {
//         0%   { opacity: 0.58; transform: rotate(-18deg) translate(0px, 0px) scale(1.00); }
//         50%  { opacity: 0.88; transform: rotate(-14deg) translate(18px,-12px) scale(1.02); }
//         100% { opacity: 0.58; transform: rotate(-18deg) translate(0px, 0px) scale(1.00); }
//       }

//       /* Lower galaxy arm: sweep top-left → bottom-right */
//       @keyframes gxArm2 {
//         0%   { opacity: 0.48; transform: rotate(12deg) translate(0px, 0px) scale(1.00); }
//         50%  { opacity: 0.75; transform: rotate(15deg) translate(-14px, 14px) scale(1.02); }
//         100% { opacity: 0.48; transform: rotate(12deg) translate(0px, 0px) scale(1.00); }
//       }

//       /* Central white-hot glow pulse */
//       @keyframes gxCore {
//         0%, 100% { opacity: 0.88; transform: scale(1.00); }
//         50%       { opacity: 1.00; transform: scale(1.07); }
//       }

//       /* Outer colour breath */
//       @keyframes gxBreath {
//         0%, 100% { opacity: 0.42; transform: scale(1.00); }
//         50%       { opacity: 0.65; transform: scale(1.05); }
//       }

//       /* Card float-in */
//       @keyframes gxFloat {
//         from { opacity: 0; transform: translateY(20px) scale(0.97); }
//         to   { opacity: 1; transform: translateY(0px)  scale(1.00); }
//       }

//       ${STAR_CSS}
//     `}
//   />
// );

// const StarLayer = () => (
//   <div
//     style={{
//       position: "fixed",
//       inset: 0,
//       pointerEvents: "none",
//       zIndex: 0,
//       overflow: "hidden",
//     }}
//   >
//     {STARS.map((_, i) => (
//       <div key={i} className={`gxs${i}`} />
//     ))}
//   </div>
// );

// const GalaxyAtmo = () => (
//   <>
//     <div
//       style={{
//         position: "fixed",
//         top: "26%",
//         left: "35%",
//         width: "45%",
//         height: "38%",
//         background: `radial-gradient(ellipse,
//         rgba(255,255,255,0.96) 0%,
//         rgba(255,252,255,0.82) 10%,
//         rgba(255,235,248,0.65) 24%,
//         rgba(255,215,242,0.44) 40%,
//         rgba(245,200,255,0.22) 58%,
//         transparent 78%
//       )`,
//         filter: "blur(20px)",
//         pointerEvents: "none",
//         zIndex: 1,
//         animation: "gxCore 5.5s ease-in-out infinite",
//       }}
//     />

//     <div
//       style={{
//         position: "fixed",
//         top: "-12%",
//         left: "-20%",
//         width: "100%",
//         height: "65%",
//         background: `linear-gradient(148deg,
//         rgba(255,255,255,0.34) 0%,
//         rgba(255,254,255,0.24) 18%,
//         rgba(248,235,255,0.16) 36%,
//         rgba(235,218,255,0.08) 55%,
//         transparent 75%
//       )`,
//         borderRadius: "50%",
//         transform: "rotate(-18deg)",
//         filter: "blur(14px)",
//         pointerEvents: "none",
//         zIndex: 1,
//         animation: "gxArm1 18s ease-in-out infinite",
//       }}
//     />

//     <div
//       style={{
//         position: "fixed",
//         bottom: "-12%",
//         right: "-15%",
//         width: "92%",
//         height: "58%",
//         background: `linear-gradient(148deg,
//         rgba(255,255,255,0.30) 0%,
//         rgba(255,252,255,0.20) 20%,
//         rgba(245,228,255,0.12) 42%,
//         rgba(232,215,255,0.06) 60%,
//         transparent 78%
//       )`,
//         borderRadius: "50%",
//         transform: "rotate(12deg)",
//         filter: "blur(16px)",
//         pointerEvents: "none",
//         zIndex: 1,
//         animation: "gxArm2 22s ease-in-out infinite",
//       }}
//     />
//     <div
//       style={{
//         position: "fixed",
//         top: "16%",
//         left: "22%",
//         width: "62%",
//         height: "58%",
//         background: `radial-gradient(ellipse at 52% 48%,
//         rgba(255,235,248,0.45) 0%,
//         rgba(255,220,242,0.28) 28%,
//         rgba(248,208,255,0.14) 52%,
//         transparent 72%
//       )`,
//         filter: "blur(34px)",
//         pointerEvents: "none",
//         zIndex: 1,
//         animation: "gxBreath 9s ease-in-out infinite",
//       }}
//     />

//     <div
//       style={{
//         position: "fixed",
//         top: "-10%",
//         right: "-8%",
//         width: "48%",
//         height: "46%",
//         background: `radial-gradient(ellipse,
//         rgba(205,228,255,0.52) 0%,
//         rgba(188,215,255,0.30) 32%,
//         rgba(205,222,255,0.12) 55%,
//         transparent 72%
//       )`,
//         filter: "blur(30px)",
//         pointerEvents: "none",
//         zIndex: 1,
//       }}
//     />

//     <div
//       style={{
//         position: "fixed",
//         top: "-5%",
//         left: "-5%",
//         width: "38%",
//         height: "42%",
//         background: `radial-gradient(ellipse,
//         rgba(105,65,188,0.56) 0%,
//         rgba(118,78,202,0.32) 36%,
//         transparent 64%
//       )`,
//         filter: "blur(28px)",
//         pointerEvents: "none",
//         zIndex: 1,
//       }}
//     />

//     <div
//       style={{
//         position: "fixed",
//         bottom: "-5%",
//         left: "10%",
//         width: "55%",
//         height: "30%",
//         background: `radial-gradient(ellipse,
//         rgba(195,148,248,0.38) 0%,
//         rgba(205,162,252,0.20) 40%,
//         transparent 68%
//       )`,
//         filter: "blur(28px)",
//         pointerEvents: "none",
//         zIndex: 1,
//       }}
//     />
//   </>
// );

// function NewHeader(props) {
//   const classes = useStyles();
//   const { leftNavbarOpen } = useSelector((s) => s.handleModelAndSideBavBar);
//   const isGuest = localStorage.getItem("is_guest") === "true";
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const currentUser = useSelector((s) => s.user.currentUser);

//   const [profilePic, setProfilePic] = useState("");
//   const [username, setusername] = useState(isGuest ? "Guest" : "");
//   const [notifications, setnotifications] = useState([]);
//   const [alerts, setalerts] = useState([]);
//   const [open, setOpen] = React.useState();
//   const [mobileOpen, setMobileOpen] = React.useState(false);
//   const [selectedMenu, setSelectedMenu] = useState("Professional Editing Tool");
//   const [bottomText, setBottomText] = useState("");
//   const userRole = sessionStorage.getItem("Role");
//   const [orgName, setOrgName] = useState("");
//   const [popoverOpen, setPopoverOpen] = useState(false);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [showSwitchRolePopup, setShowSwitchRolePopup] = useState(false);
//   const [selectedRole, setSelectedRole] = useState("");
//   const [isRoleChanged, setIsRoleChanged] = useState(false);
//   const [userDetails, setUserDetails] = useState(null);
//   const [userRoles, setUserRoles] = useState([]);
//   const [currentUserRole, setCurrentUserRole] = useState("");
//   const accessToSwitchRole = useCheckSubscriptionPlanAccess("Switch User");
//   const [subReqOpen, setSubReqOpen] = useState(false);
//   const [currentDate, setCurrentDate] = useState("");

//   const formatDate = () => {
//     const d = new Date();
//     return `${d.toLocaleDateString("en-US", { month: "short" })} ${d.getDate()} | ${d.getFullYear()}`;
//   };

//   useEffect(() => {
//     setCurrentDate(formatDate());
//   }, []);

//   useEffect(() => {
//     if (isGuest && !currentUser)
//       dispatch(
//         setCurrentUser({
//           _id: "guest",
//           username: "Guest",
//           Role: "Guest",
//           isGuest: true,
//         }),
//       );
//   }, []);

//   useEffect(() => {
//     const r = () => {
//       setWindowWidth(window.innerWidth);
//       if (window.innerWidth <= 600) handleDrawerClose();
//     };
//     window.addEventListener("resize", r);
//     if (window.innerWidth <= 600) handleDrawerClose();
//     return () => window.removeEventListener("resize", r);
//   }, []);

//   const fetchUserdetails = async () => {
//     if (isGuest) return;
//     try {
//       const res = await fetchUserData({
//         userId: sessionStorage.getItem("userId"),
//       });
//       if (res?.user) {
//         dispatch(setCurrentUser(res.user));
//         setUserDetails(res.user);
//         sessionStorage.setItem(
//           "subscriptionPlan",
//           JSON.stringify(res.user?.plan),
//         );
//         dispatch(setSubscriptionPlan(res.user.plan));
//         const fr = await getFeatures(res.user._id);
//         if (fr?.Features) {
//           sessionStorage.setItem("Features", JSON.stringify(fr.Features));
//           dispatch(setRoleFeatures(fr.Features));
//         }
//       }
//     } catch (e) {
//       console.log(e);
//     }
//   };

//   useEffect(() => {
//     let m = true;
//     const i = async () => {
//       if (!m) return;
//       await fetchUserdetails();
//       await fetchAllRoles();
//     };
//     i();
//     return () => {
//       m = false;
//     };
//   }, []);

//   const history = useHistory();
//   useEffect(() => {
//     if (isRoleChanged) history.push({ pathname: "/logout" });
//   }, [isRoleChanged]);

//   const openSwitchRole = () => {
//     if (!accessToSwitchRole) setSubReqOpen(true);
//     else setShowSwitchRolePopup(true);
//   };
//   const closeSwitchRole = () => setShowSwitchRolePopup(false);
//   const rolesForSwitch = userRoles?.filter(
//     (r, i) => i !== 0 && r !== currentUserRole,
//   );
//   const fetchAllRoles = async () => {
//     try {
//       const r = await getRolesForSwitch();
//       if (r?.userRoleList) setUserRoles(r.userRoleList);
//     } catch {}
//   };

//   const handleRoleSwitch = async () => {
//     try {
//       if (!selectedRole) return toast.warn("Role selection required.");
//       const parsed = JSON.parse(sessionStorage.getItem("subscriptionPlan"));
//       const cnt = await getUserRoleCount({
//         orgId: localStorage.getItem("organizationId"),
//         userRole: selectedRole,
//       });
//       if (
//         (currentUserRole === "Power User" &&
//           cnt.data >= parsed.userCounts.regularUser) ||
//         (currentUserRole === "Regular User" &&
//           cnt.data >= parsed.userCounts.powerUser)
//       )
//         return toast.error(`${selectedRole} limit exceeded`);
//       const res = await switchRole({
//         userId: sessionStorage.getItem("userId"),
//         newRole: selectedRole,
//       });
//       if (res.status === 200) {
//         toast.success(res.message);
//         await addUserLogs({
//           userId: userDetails._id,
//           organizationId: userDetails.organizationId,
//           actionType: "switchRole",
//           previousRole: currentUserRole,
//           newRole: selectedRole,
//         });
//         setIsRoleChanged(true);
//         setShowSwitchRolePopup(false);
//       } else toast.error("Error switching role.");
//     } catch {
//       toast.error("Internal server error.");
//     }
//   };

//   const togglePopover = () => setPopoverOpen(!popoverOpen);
//   const handleDrawerOpen = () => {
//     setOpen(true);
//     dispatch(closeRightModalAndOpenLeftNavbar());
//   };
//   const handleDrawerClose = () => {
//     setOpen(false);
//     dispatch(closeLeftNavbar());
//   };

//   useEffect(() => {
//     let m = true;
//     const l = async () => {
//       if (!m) return;
//       if (isGuest) {
//         setusername("Guest");
//         setCurrentUserRole("Guest User");
//         return;
//       }
//       try {
//         const p = await getProfile();
//         if (!m) return;
//         setOrgName(p.data.organizationName);
//         setCurrentUserRole(p.data.userRole);
//         setusername(p.data.username);
//         dispatch(setCurrentUser(p.data));
//       } catch {}
//     };
//     l();
//     return () => {
//       m = false;
//     };
//   }, [isGuest]);

//   useEffect(() => {
//     const path = window.location.pathname;
//     const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");

//     if (path.includes("/viewmydocuments/")) {
//       setSelectedMenu("Documents");
//       return;
//     }

//     const c = cap(username);
//     const d = userRole === "Organization" ? orgName : formatDate();

//     if (
//       [
//         "/paraphrase",
//         "/dashboard",
//         "/texteditor",
//         "/mydocuments",
//         "/myteam",
//         "/docTags",
//         "/citation",
//         "/plagiarism",
//         "/coauthor",
//         "/Summarizer",
//         "/translator",
//         "/reports",
//         "/accountsettings",
//         "/mynewdocuments",
//       ].includes(path)
//     ) {
//       setSelectedMenu(`Hello ${c}`);
//       setBottomText(d);
//     } else if (
//       [
//         "/faq",
//         "/alerts",
//         "/grammarcheck",
//         "/blogpage",
//         "/pricing",
//         "/invoices",
//         "/contactUs",
//         "/chat",
//         "/coauthor-newproject",
//       ].includes(path)
//     ) {
//       setSelectedMenu(`Welcome ${c}`);
//       setBottomText(formatDate());
//     } else {
//       setSelectedMenu("Professional Editing Tool");
//       setBottomText("");
//     }
//   }, [username, orgName, userRole, formatDate, setSelectedMenu, setBottomText]);

//   useEffect(() => {
//     sessionStorage.setItem(
//       "previousPath",
//       sessionStorage.getItem("currentPath"),
//     );
//     sessionStorage.setItem("currentPath", location.pathname);
//   }, [location.pathname]);

//   const markAllRead_ = async () => {
//     try {
//       if (notifications.notificationsCount < 1) return;
//       const r = await markAllRead();
//       if (r.status === 200) getNotifications_();
//     } catch {}
//   };

//   useEffect(() => {
//     let m = true;
//     if (isGuest) return;
//     const l = async () => {
//       if (!currentUser) {
//         try {
//           const u = await getProfile();
//           if (!m) return;
//           dispatch(setCurrentUser(u.data));
//         } catch {}
//       }
//     };
//     l();
//     return () => {
//       m = false;
//     };
//   }, [currentUser]);

//   useEffect(() => {
//     if (props.currentUser?.sidenavOption)
//       setOpen(props.currentUser.sidenavOption);
//   }, [props.currentUser]);

//   const getNotifications_ = async () => {
//     if (isGuest) return;
//     setnotifications(await NotificationServices.getnotifications());
//   };

//   const handleBlogDoc = () => {
//     dispatch(setBlogClick());
//     dispatch(setNavItemForCoauthor("blogs"));
//   };
//   const handleDocClick = (n) => {
//     dispatch(setDocumentClick());
//     if (n === "mydocuments") dispatch(setNavItemForCoauthor("Documents"));
//     if (n === "grammarcheck") dispatch(setNavItemForCoauthor("grammerChaeck"));
//     if (n === "coauthor") dispatch(setNavItemForCoauthor("coAuthor"));
//   };
//   const handleTags = () => dispatch(setNavItemForCoauthor("Tags"));

//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const toggleFS = async () => {
//     try {
//       if (!document.fullscreenElement) {
//         await document.documentElement.requestFullscreen();
//         setIsFullscreen(true);
//         dispatch(fullscreen());
//       } else {
//         await document.exitFullscreen();
//         setIsFullscreen(false);
//         dispatch(exitScreen());
//       }
//     } catch {}
//   };
//   useEffect(() => {
//     const h = () => setIsFullscreen(!!document.fullscreenElement);
//     document.addEventListener("fullscreenchange", h);
//     return () => document.removeEventListener("fullscreenchange", h);
//   }, []);

//   function urlMatch(p) {
//     return matchPath(location.pathname, {
//       path: p,
//       exact: true,
//       strict: false,
//     });
//   }

//   const notifPop = (
//     <Popover id="np" style={{ zIndex: 9999, minWidth: 400 }}>
//       <Popover.Content
//         style={{
//           overflowY: "auto",
//           maxHeight: "40vh",
//           minWidth: 400,
//           background: "rgba(50,18,115,0.96)",
//           backdropFilter: "blur(22px)",
//           color: "#f5eeff",
//           borderRadius: 8,
//         }}
//       >
//         <div
//           style={{
//             position: "sticky",
//             top: -7,
//             zIndex: 1,
//             paddingTop: 5,
//             display: "flex",
//             justifyContent: "space-between",
//           }}
//         >
//           <h6 style={{ color: "#f0e8ff" }}>
//             <b>Notification</b>
//           </h6>
//           <p
//             style={{
//               color: "#c8a8ff",
//               fontSize: 10,
//               bottom: -4,
//               position: "relative",
//               cursor: "pointer",
//             }}
//             onClick={() => {
//               markAllRead_();
//               togglePopover();
//             }}
//           >
//             Mark all as read
//           </p>
//         </div>
//         <hr style={{ borderColor: "rgba(255,255,255,0.15)" }} />
//         <NotificationCard data={notifications} />
//       </Popover.Content>
//     </Popover>
//   );

//   const userDrop = (
//     <Popover id="ud" style={{ zIndex: 9999 }}>
//       <Popover.Content
//         style={{
//           background: "rgba(50,18,115,0.96)",
//           backdropFilter: "blur(20px)",
//           border: "1px solid rgba(210,175,255,0.22)",
//           borderRadius: 12,
//           padding: 8,
//         }}
//       >
//         {[
//           { label: "Account Settings", to: "/accountsettings" },
//           ...(props.currentUser &&
//           ((props.currentUser.Role === "Organization" &&
//             props.currentUser.isAdmin) ||
//             props.currentUser.Role === "Individual")
//             ? [{ label: "Subscriptions", to: "/pricing" }]
//             : []),
//           ...(props.currentUser?.accountType === "Personal"
//             ? [{ label: "Invoices", to: "/invoices" }]
//             : []),
//           { label: "Support", to: "/contactUs" },
//           { label: "Log Out", to: "/logout" },
//         ].map((it) => (
//           <NavLink key={it.to} to={it.to} style={{ textDecoration: "none" }}>
//             <MenuItem
//               style={{ color: "#ffffff", borderRadius: 8, fontSize: "0.88rem" }}
//             >
//               {it.label}
//             </MenuItem>
//           </NavLink>
//         ))}
//       </Popover.Content>
//     </Popover>
//   );

//   const NAV = [
//     {
//       label: "Dashboard",
//       icon: <DashboardOutlinedIcon style={{ fontSize: 22,  fontWeight: 600 , }} />,
//       to: "/dashboard",
//       match: ["/dashboard"],
//     },
//     {
//       label: "SmartDoc Library",
//       icon: <DescriptionOutlinedIcon style={{ fontSize: 22 }} />,
//       to: "/mydocuments",
//       match: ["/mydocuments", "/documentpreview/:id", "/viewmydocuments/:id"],
//       fn: () => handleDocClick("mydocuments"),
//     },
//     {
//       label: "Grammar Check",
//       icon: <SpellcheckIcon style={{ fontSize: 22 }} />,
//       to: "/grammarcheck",
//       match: ["/grammarcheck"],
//       fn: () => handleDocClick("grammarcheck"),
//     },
//     {
//       label: "Team Hub",
//       icon: <GroupOutlinedIcon style={{ fontSize: 22 }} />,
//       to: "/myteam",
//       match: ["/myteam"],
//     },

//     {
//       label: "Synthium Studio",
//       icon: <EditNoteIcon style={{ fontSize: 22 }} />,
//       to: "/coauthor",
//       match: ["/coauthor", "/coauthor-newproject"],
//       fn: () => handleDocClick("coauthor"),
//     },
//     {
//       label: "AI Intelligence",
//       icon: <AssessmentIcon style={{ fontSize: 22 }} />,
//       to: "/reports",
//       match: ["/reports"],
//     },
//     {
//       label: "MultiTool AI",
//       icon: <LocalOfferIcon style={{ fontSize: 22 }} />,
//       to: "/docTags",
//       match: [
//         "/docTags",
//         "/Summarizer",
//         "/paraphrase",
//         "/translator",
//         "/plagiarism",
//         "/citation",
//       ],
//       fn: handleTags,
//     },
//     {
//       label: "Blogs",
//       icon: <FeedIcon style={{ fontSize: 22 }} />,
//       to: "/blogpage",
//       match: ["/blogpage", "/blogpreview/:id"],
//       fn: handleBlogDoc,
//     },
//     {
//       label: "FAQ",
//       icon: <HelpOutlineIcon style={{ fontSize: 22 }} />,
//       to: "/faq",
//       match: ["/faq"],
//     },
//   ].filter((it, i, a) => a.findIndex((t) => t.label === it.label) === i);

//   return (
//     <div className={classes.root} style={{ position: "relative" }}>
//       <div
//         style={{
//           position: "fixed",
//           inset: 0,
//           zIndex: -1,
//           background: GALAXY_BACKGROUND,
//         }}
//       />
//       <GalaxyCSS />
//       <StarLayer />
//       <GalaxyAtmo />

//       <CssBaseline />

//       {/* ── AppBar ── */}
//       <AppBar
//         position="fixed"
//         className={clsx(classes.appBar, {
//           [classes.appBarShift]: leftNavbarOpen,
//         })}
//       >
//         <Toolbar className={classes.toolbar}>
//           <NavTooltip title="Click to Expand">
//             <IconButton
//               onClick={handleDrawerOpen}
//               className={clsx(classes.logoBtn, {
//                 [classes.hide]: leftNavbarOpen,
//               })}
//             >
//               <img
//                 alt="logo"
//                 src={Poetlogopen}
//                 style={{
//                   height: "42px",
//                   width: "42px",
//                   objectFit: "contain",
//                   filter: "drop-shadow(0 0 7px rgba(93, 0, 255, 0.65))",
//                 }}
//               />
//             </IconButton>
//           </NavTooltip>

//           <div className={classes.welcomeBox}>
//             <span className={classes.welcomeName}>
//               Welcome {isGuest ? "Guest" : username}
//             </span>
//             <span className={classes.welcomeDate}>{currentDate}</span>
//           </div>

//           <div className={classes.grow} />

//           <div className={classes.rightRow}>
//             <NavTooltip title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}>
//               <IconButton className={classes.iconBtn} onClick={toggleFS}>
//                 {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
//               </IconButton>
//             </NavTooltip>

//             {userDetails?.originalRole?.userRole === userRoles[1] && (
//               <NavTooltip title="Switch Role">
//                 <IconButton
//                   className={classes.iconBtn}
//                   onClick={openSwitchRole}
//                 >
//                   <SwitchAccountIcon />
//                 </IconButton>
//               </NavTooltip>
//             )}

//             <SubscriptionRequired open={subReqOpen} setOpen={setSubReqOpen} />

//             <OverlayTrigger
//               trigger="click"
//               placement="bottom"
//               overlay={notifPop}
//               rootClose
//               show={popoverOpen}
//             >
//               <NavTooltip title="Notifications">
//                 <IconButton
//                   className={classes.notifBtn}
//                   onClick={togglePopover}
//                   disabled={notifications.notificationsCount < 1}
//                 >
//                   <Badge
//                     badgeContent={
//                       notifications.notificationsCount > 0
//                         ? notifications.notificationsCount
//                         : null
//                     }
//                     color="secondary"
//                     className={classes.badge}
//                   >
//                     <NotificationsIcon />
//                   </Badge>
//                   {notifications.notificationsCount > 0 && (
//                     <div className={classes.notifDot} />
//                   )}
//                 </IconButton>
//               </NavTooltip>
//             </OverlayTrigger>

//             <OverlayTrigger
//               trigger="click"
//               placement="bottom"
//               overlay={userDrop}
//               rootClose
//             >
//               <div className={classes.userPill}>
//                 <Avatar
//                   src={profilePic || avatar}
//                   alt={username}
//                   className={classes.userAvatar}
//                 />
//                 <div className={classes.userTextBox}>
//                   <span className={classes.userName}>
//                     {isGuest ? "Guest" : username}
//                   </span>
//                   <span className={classes.userRole}>
//                     {isGuest ? "Guest User" : currentUserRole}
//                   </span>
//                 </div>
//               </div>
//             </OverlayTrigger>
//           </div>
//         </Toolbar>
//       </AppBar>

//       {/* ── Switch Role Modal ── */}
//       <Modal
//         isOpen={showSwitchRolePopup}
//         toggle={() => setShowSwitchRolePopup(!showSwitchRolePopup)}
//         style={{
//           position: "absolute",
//           left: "50%",
//           top: "50%",
//           transform: "translate(-50%,-50%)",
//           width: "50%",
//         }}
//       >
//         <div
//           style={{
//             padding: 25,
//             background: "rgba(42,14,108,0.98)",
//             backdropFilter: "blur(28px)",
//             borderRadius: 14,
//             border: "1px solid rgba(210,175,255,0.28)",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//             <h3 style={{ color: "#d4a8ff", marginBottom: 0 }}>Switch Role</h3>
//             <CloseIcon
//               style={{ color: "#f87070", cursor: "pointer" }}
//               onClick={closeSwitchRole}
//             />
//           </div>
//           <div style={{ width: "85%", margin: "22px auto" }}>
//             <FormControl component="fieldset">
//               <RadioGroup
//                 value={selectedRole}
//                 onChange={(e) => setSelectedRole(e.target.value)}
//               >
//                 {rolesForSwitch.map((role, i) => (
//                   <FormControlLabel
//                     key={i}
//                     value={role}
//                     control={<Radio style={{ color: "#c4a0ff" }} />}
//                     label={<span style={{ color: "#f0e8ff" }}>{role}</span>}
//                   />
//                 ))}
//               </RadioGroup>
//             </FormControl>
//           </div>
//           <div
//             style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
//           >
//             <Button
//               onClick={handleRoleSwitch}
//               style={{
//                 color: "#fff",
//                 background: "linear-gradient(135deg,#6820c8,#c090ff)",
//                 borderRadius: 8,
//                 padding: "8px 28px",
//                 fontFamily: "'Outfit',sans-serif",
//                 fontWeight: 600,
//               }}
//             >
//               Switch
//             </Button>
//           </div>
//         </div>
//       </Modal>

//       <Drawer
//         variant="permanent"
//         className={clsx(classes.drawer, {
//           [classes.drawerOpen]: leftNavbarOpen,
//           [classes.drawerClose]: !leftNavbarOpen,
//         })}
//         classes={{
//           paper: clsx(classes.drawerPaper, {
//             [classes.drawerOpen]: leftNavbarOpen,
//             [classes.drawerClose]: !leftNavbarOpen,
//           }),
//         }}
//         open={mobileOpen}
//         onClose={() => setMobileOpen(!mobileOpen)}
//         id="normalsidenav"
//       >
//         <div className={classes.sidePanel} style={{ position: "relative" }}>
//           <SideNavStars />
//           {/* Logo row */}
//           <div className={classes.sideLogoRow} style={{ position: "relative", zIndex: 1 }}>
//             <IconButton
//               onClick={handleDrawerClose}
//               size="small"
//               style={{
//                 position: "absolute",
//                 right: 8,
//                 background: "rgba(210,175,255,0.18)",
//                 color: "#3300ff",
//                 border: "1px solid rgba(94, 61, 255, 0.77)",
//               }}
//             >
//               <ChevronLeftIcon />
//             </IconButton>
//             <div
//               style={{ display: "flex", alignItems: "center", flex: 1, gap: 8 }}
//             >
//               <img
//                 alt="logo"
//                 src={Poetlogopen}
//                 className={classes.sideLogoImg}
//               />
//               {leftNavbarOpen && (
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     flex: 1,
//                     overflow: "hidden",
//                   }}
//                 >
//                   <Typography
//                     style={{
//                       color: "#0400ff",
//                       fontWeight: 800,
//                       fontSize: "1.28rem",
//                       lineHeight: 1.2,
//                       fontFamily: "'Outfit',sans-serif",
//                       textShadow: "0 0 14px rgba(205,170,255,0.65)",
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                     }}
//                   >
//                     Synthium
//                   </Typography>
//                   <Typography
//                     style={{
//                       color: "#0400ff",
//                       fontSize: "0.76rem",
//                       fontWeight: 400,
//                       fontFamily: "'Outfit',sans-serif",
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                     }}
//                   >
//                     Creative Suite
//                   </Typography>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Nav items */}
//           <div className={classes.navWrapper}>
//             <div className={classes.navScroll}>
//               <List className="drawerMenu pointer" id="menuList">
//                 {NAV.map((item, idx) => {
//                   const active = item.match.some((p) => urlMatch(p));
//                   return (
//                     <ListItem
//                       key={idx}
//                       button
//                       onClick={() => {
//                         if (item.fn) item.fn();
//                         window.location.href = item.to;
//                       }}
//                       style={{ padding: 0 }}
//                     >
//                       <ListItem
//                         className={clsx(classes.navRow, {
//                           [classes.navRowActive]: active,
//                         })}
//                       >
//                         <ListItemIcon className={classes.navIcon}>
//                           <NavTooltip
//                             title={leftNavbarOpen ? "" : item.label}
//                             placement="right"
//                           >
//                             <span
//                               style={{
//                                 color: active
//                                   ? "#ffffff"
//                                   : "rgba(232,215,255,0.90)",
//                               }}
//                             >
//                               {item.icon}
//                             </span>
//                           </NavTooltip>
//                         </ListItemIcon>
//                         {leftNavbarOpen && (
//                           <Typography
//                             className={classes.navText}
//                             style={{
//                               color: active
//                                 ? "#ffffff"
//                                 : "rgb(255, 255, 255)",
//                               fontWeight: active ? 700 : 500,
//                             }}
//                           >
//                             {item.label}
//                           </Typography>
//                         )}
//                       </ListItem>
//                     </ListItem>
//                   );
//                 })}
//               </List>
//             </div>
//           </div>
//         </div>
//       </Drawer>

//       {/* ── Main content ── */}
//       <main
//         className={clsx(classes.content, {
//           [classes.contentShift]: leftNavbarOpen,
//         })}
//       >
//         <div
//           style={{
//             position: "absolute",
//             inset: 0,
//             pointerEvents: "none",
//             zIndex: 0,
//             overflow: "hidden",
//           }}
//         >
//           {STARS.slice(0, 45).map((s, i) => (
//             <div
//               key={i}
//               style={{
//                 position: "absolute",
//                 left: `${s.px}%`,
//                 top: `${s.py}%`,
//                 width: `${s.sz}px`,
//                 height: `${s.sz}px`,
//                 borderRadius: "50%",
//                 background: "#ffffff",
//                 boxShadow: `0 0 ${(s.sz * 3.2).toFixed(1)}px rgba(255,255,255,0.95), 0 0 ${(s.sz * 1.6).toFixed(1)}px rgba(255,255,255,0.78)`,
//                 animation: `gxTwinkle ${s.dr}s ease-in-out ${s.dl}s infinite`,
//                 pointerEvents: "none",
//               }}
//             />
//           ))}
//         </div>
//         <div
//           style={{
//             position: "absolute",
//             top: "-10%",
//             left: "-18%",
//             width: "98%",
//             height: "62%",
//             background:
//               "linear-gradient(148deg, rgba(255,255,255,0.28) 0%, rgba(255,252,255,0.18) 20%, rgba(242,228,255,0.10) 40%, transparent 68%)",
//             borderRadius: "50%",
//             transform: "rotate(-18deg)",
//             filter: "blur(15px)",
//             pointerEvents: "none",
//             zIndex: 0,
//             animation: "gxArm1 18s ease-in-out infinite",
//           }}
//         />
//         <div
//           style={{
//             position: "absolute",
//             bottom: "-10%",
//             right: "-12%",
//             width: "88%",
//             height: "55%",
//             background:
//               "linear-gradient(148deg, rgba(255,255,255,0.24) 0%, rgba(255,250,255,0.15) 22%, rgba(240,222,255,0.08) 44%, transparent 70%)",
//             borderRadius: "50%",
//             transform: "rotate(12deg)",
//             filter: "blur(17px)",
//             pointerEvents: "none",
//             zIndex: 0,
//             animation: "gxArm2 22s ease-in-out infinite",
//           }}
//         />
//         <div
//           style={{
//             position: "absolute",
//             top: "18%",
//             left: "25%",
//             width: "52%",
//             height: "52%",
//             background:
//               "radial-gradient(ellipse at 55% 46%, rgba(255,255,255,0.24) 0%, rgba(255,238,250,0.16) 24%, rgba(248,215,255,0.08) 50%, transparent 70%)",
//             filter: "blur(28px)",
//             pointerEvents: "none",
//             zIndex: 0,
//             animation: "gxCore 5.5s ease-in-out infinite",
//           }}
//         />

//         <div className={classes.toolbar2} />
//         <div style={{ position: "relative", zIndex: 2 }}>{props.children}</div>
//       </main>
//     </div>
//   );
// }

// const mSTP = (s) => ({
//   currentUser: s.user.currentUser,
//   isAuth: s.user.isAuth,
// });
// const mDTP = (d) => ({
//   setCurrentUser: (u) => d(setCurrentUser(u)),
//   setUserFeatures: (f) => d(setUserFeatures(f)),
//   setRoleFeatures: (rf) => d(setRoleFeatures(rf)),
//   setSubscriptionPlan: (p) => d(setSubscriptionPlan(p)),
// });
// export default connect(mSTP, mDTP)(withRouter(NewHeader));



